<template>
  <div class="row m-0 p-0">
    <div class="col-lg-6 ml-0 pl-0">
      <b-table :fields="finalGradeFinalGradesModalFields"
               :items="[proposal]"
               class="table-responsive"
               head-variant="light"
               responsive
               striped>
        <template v-slot:cell(created_at)="row">
          {{ row.item.states.date | moment('DD-MM-YYYY HH:mm') }}
        </template>
        <template v-slot:cell(actions)="row">
          <action-download-pdf :proposal="row.item"/>
        </template>
      </b-table>
      <rapid-access-final-grade-form v-if="showFinalGrade"
                                     v-model="proposal"
                                     :is-editable="isManagementEvaluation ? false : isFinalGradeEditable"
                                     @close-modal="closeModalEmit"/>
    </div>

    <div class="col-lg-6 mr-0 pr-0">
      <evaluations-summary-table :value="proposal"/>
      <div v-if="isManagementEvaluation">
        <rapid-access-grade-dates-table :proposal="proposal"/>
        <rapid-access-management-evaluation-form v-model="proposal"
                                                 :isUserEditor="isUserEditor"
                                                 @close-modal="closeModalEmit"/>
      </div>
    </div>
  </div>
</template>

<script>
  import ActionDownloadPdf from '@/components/actions/ActionDownloadPdf';
  import { infrastructureMixin } from '@/mixins/infrastructure';
  import RapidAccessFinalGradeForm from '@/components/evaluation/rapid-access/final-grade/RapidAccessFinalGradeForm';
  import EvaluationsSummaryTable from '@/components/evaluation/EvaluationsSummaryTable';
  import RapidAccessGradeDatesTable from '@/components/evaluation/RapidAccessGradeDatesTable';
  import RapidAccessManagementEvaluationForm
    from '@/components/evaluation/rapid-access/management/RapidAccessManagementEvaluationForm';
  import options from '@/json/feasibility';

  export default {
    name: 'RapidAccessGradeModal',
    components: {
      ActionDownloadPdf,
      RapidAccessFinalGradeForm,
      EvaluationsSummaryTable,
      RapidAccessGradeDatesTable,
      RapidAccessManagementEvaluationForm,
    },
    mixins: [infrastructureMixin],
    props: {
      value: {
        type: Object,
        default: () => {
        },
      },
      isUserEditor: {
        type: Boolean,
        required: true,
      },
      isManagementEvaluation: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        proposal: this.value,
        options: options.options,
        finalGradeFinalGradesModalFields: [],
      };
    },
    computed: {
      isRapidAccessWithoutFinalGrade() {
        return !('final_grade' in this.proposal);
      },
      showFinalGrade() {
        return !(this.isManagementEvaluation && this.isRapidAccessWithoutFinalGrade);
      },
      isFinalGradeEditable() {
        const isFinalGradeStateEditable = !this.isRapidAccessWithoutFinalGrade
          && !this.proposal.final_grade.states?.name.includes('submitted');
        return this.isUserEditor && isFinalGradeStateEditable;
      },
    },
    watch: {
      value() {
        this.proposal = this.value;
      },
      proposal: {
        handler() {
          this.$emit('input', this.proposal);
        },
        deep: true,
      },
    },
    async created() {
      const rapidAccessHelpers = await this.getRapidAccessEvaluationDashboardProperties(
        this.infrastructure,
        'FinalGrade',
      );
      this.finalGradeFinalGradesModalFields = rapidAccessHelpers.getSingleField('finalGradeFinalGradesModalFields');
    },
  };
</script>

<style lang="scss" scoped>
  .table-responsive {
    margin-bottom: 0;
  }

  .header {
    color: #495057;
  }
</style>
